import React from 'react';
import PropTypes from 'prop-types';

/**
 * ProposedInsuredSection Component
 * Form section for proposed insured information
 */
const ProposedInsuredSection = ({ formData, onInputChange, styles, formType }) => {
  // Determine field names based on form type
  const firstNameField = formType === 'annuity' ? 'proposedInsuredAnnuityFirstName' : 'proposedInsuredLifeFirstName';
  const lastNameField = formType === 'annuity' ? 'proposedInsuredAnnuityLastName' : 'proposedInsuredLifeLastName';
  
  return (
    <>
      {/* First Name */}
      <div style={styles.formGroup} data-itemid='firstName-wrapper'>
        <label style={styles.label} data-itemid='firstName-label'>
          First Name
        </label>
        <input
          data-itemid='firstName-field'
          onChange={e => onInputChange(firstNameField, e.target.value)}
          placeholder=''
          style={styles.input}
          type='text'
          value={formData[firstNameField] || ''}
        />
      </div>

      {/* Last Name */}
      <div style={styles.formGroup} data-itemid='lastName-wrapper'>
        <label style={styles.label} data-itemid='lastName-label'>
          Last Name
        </label>
        <input
          data-itemid='lastName-field'
          onChange={e => onInputChange(lastNameField, e.target.value)}
          placeholder=''
          style={styles.input}
          type='text'
          value={formData[lastNameField] || ''}
        />
      </div>
    </>
  );
};

ProposedInsuredSection.propTypes = {
  formData: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  styles: PropTypes.object.isRequired,
  formType: PropTypes.string
};

ProposedInsuredSection.defaultProps = {
  formType: 'annuity'
};

export default ProposedInsuredSection;
